import axios from 'axios'
import authHeader from './auth-header'
import ConstApiUrls from './const-api-urls'

export default {
  current: () => axios.get(`${ConstApiUrls.API_SERVICE_URL}accounting/current-context`, { headers: authHeader() }),
}
